import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-base-upload",
  "use": "rt-base-upload-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"rt-base-upload\"><defs><style type=\"text/css\"></style></defs><path d=\"M391.7 256.9c-4.1 5.2-0.4 12.9 6.3 12.9h71.9v346.3c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V269.7H622c6.7 0 10.4-7.7 6.3-12.9l-112-141.7c-3.2-4.1-9.4-4.1-12.6 0l-112 141.8z\" p-id=\"2554\" /><path d=\"M901 516h-64c-4.4 0-8 3.6-8 8v300c0 4.4-3.6 8-8 8H197c-4.4 0-8-3.6-8-8V524c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v372c0 8.8 7.2 16 16 16h768c8.8 0 16-7.2 16-16V524c0-4.4-3.6-8-8-8z\" p-id=\"2555\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/upload.svg
// module id = 1284
// module chunks = 124